module.exports = __webpack_public_path__ + "img/cog.c3e41fc6.svg";